/*
 * Aurea — AI Trauma, Mental Awareness & Wellbeing Application
 * Copyright (c) 2026 Damian Alan Moses. All Rights Reserved.
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import { Terms, Privacy } from "@/pages/Legal";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Verify from "@/pages/Verify";
import Dashboard from "@/pages/Dashboard";
import Companion from "@/pages/Companion";
import Journal from "@/pages/Journal";
import Mood from "@/pages/Mood";
import Tools from "@/pages/Tools";
import Therapists from "@/pages/Therapists";
import Resources from "@/pages/Resources";
import Settings from "@/pages/Settings";
import Admin from "@/pages/Admin";
import Gateway from "@/pages/gateway/Gateway";
import Emptiness from "@/pages/gateway/Emptiness";
import Chaos from "@/pages/gateway/Chaos";
import Readiness from "@/pages/gateway/Readiness";
import Plus from "@/pages/Plus";
import Sounds from "@/pages/Sounds";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/verify" element={<ProtectedRoute><Verify /></ProtectedRoute>} />
            <Route path="/gateway" element={<Gateway />} />
            <Route path="/gateway/emptiness" element={<Emptiness />} />
            <Route path="/gateway/chaos" element={<Chaos />} />
            <Route path="/gateway/readiness" element={<Readiness />} />
            <Route path="/sounds" element={<Sounds />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="companion" element={<Companion />} />
              <Route path="journal" element={<Journal />} />
              <Route path="mood" element={<Mood />} />
              <Route path="tools" element={<Tools />} />
              <Route path="therapists" element={<Therapists />} />
              <Route path="resources" element={<Resources />} />
              <Route path="plus" element={<Plus />} />
              <Route path="settings" element={<Settings />} />
              <Route path="admin" element={<Admin />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
